import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_02_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-02-01",
    "name": "俯身器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["胸贴凳面", "拉至下腹部"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/24f41094a5f937ed8ec003fd.mp4",
    "videoUrl": "/media/collections-20261008/videos/5029ccf0def20bbfa0ef9581.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-02-02",
    "name": "坐姿器械划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "row",
    "tips": ["背部挺直", "肩胛后缩挤压"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/145e19f594dd4522d64ba27e.mp4",
    "videoUrl": "/media/collections-20261008/videos/55f62bdc6f582af6d97967f8.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-02-03",
    "name": "反握直臂下压",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "width",
    "tips": ["反握增加二头参与", "全程控制"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "targetMuscles": ["背阔肌", "大圆肌"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "mediaIssue": "新文件实际为反手高位下拉，反握直臂下压素材待补齐",
    "demoStatus": "pending",
  },
  {
    "id": "course-20261008-fanjue-plan-02-04",
    "name": "高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["沉肩下拉", "感受背阔收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/79591c024b74071f890a2467.mp4",
    "videoUrl": "/media/collections-20261008/videos/2fb3813bd9b3d8c0e9a4cf86.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
